import { makeUid, rootAttrs, innerAttrs } from '../utils'

export const sharedComputedProps = {
  data () {
    return { cuiUid: makeUid() }
  },
  computed: {
    computedIsValid () {
      if (typeof this.isValid === 'function') return this.isValid(this.state)
      return this.isValid
    },
    validationClass () {
      if (typeof this.computedIsValid === 'boolean') return this.computedIsValid ? 'is-valid' : 'is-invalid'
      return undefined
    },
    safeId () {
      const id = this.$props.id || this.$attrs.id
      return id || this.cuiUid
    },
    /** Vue 2 put class/style on the wrapper and the rest of $attrs (+ listeners) on the control */
    wrapperAttrs () {
      return rootAttrs(this.$attrs)
    },
    controlAttrs () {
      return innerAttrs(this.$attrs)
    }
  }
}

export const wrapperComputedProps = {
  computed: {
    isHorizontal () {
      return Boolean(this.horizontal)
    },
    haveInputGroup () {
      return Boolean(
        this.tooltipFeedback ||
        this.append ||
        this.prepend ||
        this.$slots.append ||
        this.$slots.prepend ||
        this.$slots['append-content'] ||
        this.$slots['prepend-content']
      )
    },
    haveWrapper () {
      return this.haveInputGroup || Boolean(this.addWrapperClasses || this.isHorizontal)
    },
    wrapperClasses () {
      if (this.haveWrapper) {
        return [
          this.addWrapperClasses,
          {
            [this.horizontal.input || 'col-sm-9']: this.isHorizontal,
            'input-group': this.haveInputGroup,
            [`input-group-${this.size}`]: this.haveCustomSize
          }
        ]
      }
      return undefined
    }
  }
}

/** keeps the internal state in sync with `value` (`.sync` / v-model:value) and `modelValue` (v-model) */
export const watchValue = {
  watch: {
    value (val) {
      this.state = val
    },
    modelValue (val) {
      this.state = val
    }
  }
}

export const classesComputedProps = {
  computed: {
    haveCustomSize () {
      return ['sm', 'lg'].includes(this.size)
    },
    computedClasses () {
      return [
        'form-group',
        {
          'was-validated': this.wasValidated,
          'form-row': this.isHorizontal
        }
      ]
    },
    labelClasses () {
      return [
        this.addLabelClasses,
        {
          'col-form-label': this.isHorizontal,
          [this.horizontal.label || 'col-sm-3']: this.isHorizontal,
          [`col-form-label-${this.size}`]: this.haveCustomSize
        }
      ]
    },
    customSizeClass () {
      if (this.haveCustomSize && !this.haveWrapper) return `form-control-${this.size}`
      return undefined
    },
    inputClasses () {
      return [
        (this.$options.computed && this.$options.computed.inputClass ? this.inputClass : undefined) || `form-control${this.plaintext ? '-plaintext' : ''}`,
        this.validationClass,
        this.addInputClasses,
        this.customSizeClass
      ]
    }
  }
}

/** initial value: v-model (modelValue) wins over value */
export function initialValue (vm) {
  return vm.modelValue !== undefined ? vm.modelValue : vm.value
}
